jQuery_T4NT(document).ready(function($) {

        $('.t4s-navigation').hover(function() {
          $('html').addClass('is-header--stuck');
        }, function() {
          //$('html').removeClass('is-header--stuck');
          if (!$('.t4s-section-header').is(':hover')) {
            $('html').removeClass('is-header--stuck');
          }
        }); 
      

});
    // Selecciona todos los botones para abrir modales
const botonesModal = document.querySelectorAll('.boton-modal');

// Agrega un evento click a cada botón
botonesModal.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = document.querySelector(boton.dataset.modal); // Encuentra el modal correspondiente al botón
    modal.classList.add('mostrar'); // Agrega la clase "mostrar" para mostrar el modal
    document.querySelector('body').style.overflowY = 'hidden'; // Prevent body from scrolling down
  });
});

// Selecciona todos los botones para cerrar modales
const botonesCerrar = document.querySelectorAll('.modal-cerrar');

// Agrega un evento click a cada botón
botonesCerrar.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = boton.closest('.modal'); // Encuentra el modal más cercano al botón
    modal.classList.remove('mostrar'); // Quita la clase "mostrar" para ocultar el modal
    document.querySelector('body').style.overflowY = 'auto' // Make body scrollable again
  });
});

// Cierra el modal si se hace clic fuera del contenido
window.addEventListener('click', evento => {
  const modales = document.querySelectorAll('.modal');
  modales.forEach(modal => {
    if (evento.target === modal) {
      modal.classList.remove('mostrar');
      document.querySelector('body').style.overflowY = 'auto' // Make body scrollable again
    }
  });
});

// Cierra el modal si se presiona la tecla Esc
window.addEventListener('keydown', evento => {
  const modales = document.querySelectorAll('.modal');
  modales.forEach(modal => {
    if (evento.key === 'Escape') {
      modal.classList.remove('mostrar');
      document.querySelector('body').style.overflow = 'auto' // Make body scrollable again
    }
  });
});

const cartElements = document.querySelectorAll('.custom-mobile-cart');

// Agrega un evento de clic a cada elemento
cartElements.forEach(cartElement => {
  cartElement.addEventListener('click', () => {
    // Obtén todos los elementos con la clase 'custom-pr-btns'
    const btnsElement = cartElement.nextElementSibling;
    console.log(btnsElement)
    const allBtnsElements = document.querySelectorAll('.custom-pr-btns');
    allBtnsElements.forEach(element => {
      element.classList.remove('custom-active-mobile');
    });
    // Agrega la clase 'custom-active-mobile' si se encontró el elemento
    if (btnsElement && btnsElement.classList.contains('custom-pr-btns')) {
      btnsElement.classList.add('custom-active-mobile');
    }
  });
});

const formData = new FormData(this.querySelector("#FacetFiltersForm"));

let newSearchParams = new URLSearchParams(formData).toString();
if (newSearchParams.includes("filter.v.option") && !newSearchParams.includes("filter.v.availability")) {
newSearchParams = newSearchParams + "&filter.v.availability=1"; }
triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${newSearchParams}` });